module.exports = __webpack_public_path__ + "img/woman-arm-back.47660072.png";